import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BuatEmailService from "../../services/BuatEmailService";
import {message} from "antd";
import {
    AUTH_TOKEN,
    FOTO_CMHS
} from "../../constants/AuthConstant";

export const initialState = {
    loadingBuatEmail: false,
    statusBuatEmail:'',
    showMessage:false,
    message:'',
}


export const postBuatEmail = createAsyncThunk('transaksi/buatemail',async (data, { rejectWithValue }) => {
    try {
        const response = await BuatEmailService.post(localStorage.getItem(AUTH_TOKEN))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        //console.log(JSON.stringify(response))
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Error',3,function (err) {
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem(FOTO_CMHS);

            window.location.href = "auth/login";
        })
    }
})



export const buatEmailSlice = createSlice({
    name: 'buat_email',
    initialState,
    reducers: {
            showLoadingBuatEmail: (state) => {
                state.loadingBuatEmail = true
            },
        },
    extraReducers: (builder) => {
        builder
            .addCase(postBuatEmail.fulfilled, (state, action) => {
                state.loadingBuatEmail = false
                state.statusBuatEmail = action.payload.success
            })
            .addCase(postBuatEmail.pending,(state,action)=>{
                state.loadingBuatEmail=true
            })
            .addCase(postBuatEmail.rejected, (state, action) => {
                state.message = action.payload.message
                state.showMessage = true
                state.loadingBuatEmail = false
                state.statusBuatEmail = action.payload.success
            })
    },
})

export const {
    showLoadingBuatEmail
} = buatEmailSlice.actions

export default buatEmailSlice.reducer
